import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { FileOrderDetailsPayload, TranslationRequestInput } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = TranslationRequestInput;
type TData = FileOrderDetailsPayload;

export const useTranslationRequestFileOrderDetails = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation translationRequestFileOrderDetails($input: TranslationRequestInput!) {
      translationRequestFileOrderDetails(input: $input) {
        success
        errors
        errorCode
        guid
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
